<template>
  <div class="debt-installment-warranty-pagination">
    <b-row>
      <b-col lg="3" md="3" sm="12">
        <p class="debt-installment-warranty-pagination__total mt-3 text-dark" :aria-label="`Tổng số bản ghi: ${total}`">
          Tổng số: {{ total }}
        </p>
      </b-col>
      <b-col lg="9" md="9" sm="12">
        <b-pagination-nav
          class="debt-installment-warranty-pagination__nav custom-pagination"
          v-show="totalPages >= 2"
          :link-gen="linkGenerator"
          :number-of-pages="totalPages"
          use-router
          @change="onPageChange"
          align="right"
          first-class="page-item-first btn btn-icon btn-sm m-1"
          prev-class="page-item-prev btn btn-icon btn-sm m-1"
          next-class="page-item-next btn btn-icon btn-sm m-1"
          last-class="page-item-last btn btn-icon btn-sm m-1"
          page-class="btn btn-icon btn-sm border-0 m-1"
          :aria-label="paginationAriaLabel"
        >
          <template v-slot:first-text>
            <span :aria-label="firstPageAriaLabel"><i class="ki ki-bold-double-arrow-back icon-xs"></i></span>
          </template>
          <template v-slot:prev-text>
            <span :aria-label="prevPageAriaLabel"><i class="ki ki-bold-arrow-back icon-xs"></i></span>
          </template>
          <template v-slot:next-text>
            <span :aria-label="nextPageAriaLabel"><i class="ki ki-bold-arrow-next icon-xs"></i></span>
          </template>
          <template v-slot:last-text>
            <span class="text-info" :aria-label="lastPageAriaLabel"><i class="ki ki-bold-double-arrow-next icon-xs"></i></span>
          </template>
        </b-pagination-nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'DebtInstallmentWarrantyPagination',
  props: {
    total: { type: Number, default: 0, validator: (v) => v >= 0 },
    totalPages: { type: Number, default: 1, validator: (v) => v >= 1 },
    currentPage: { type: Number, default: 1, validator: (v) => v >= 1 },
    pageSize: { type: Number, default: 10, validator: (v) => v > 0 },
    filterParams: { type: Object, default: () => ({}) },
    routeName: { type: String, default: 'list-debt-installment-warranty' },
  },
  computed: {
    paginationAriaLabel() {
      return `Điều hướng phân trang, trang hiện tại: ${this.currentPage} / ${this.totalPages}`;
    },
    firstPageAriaLabel() {
      return 'Đi đến trang đầu tiên';
    },
    prevPageAriaLabel() {
      return 'Đi đến trang trước';
    },
    nextPageAriaLabel() {
      return 'Đi đến trang tiếp theo';
    },
    lastPageAriaLabel() {
      return 'Đi đến trang cuối cùng';
    },
  },
  methods: {
    linkGenerator(pageNum) {
      const params = this.buildUrlParams();
      params.page = pageNum || 1;
      return {
        name: this.routeName,
        query: _.omitBy(params, _.isNil),
      };
    },
    onPageChange(page) {
      this.$emit('page-change', page);
    },
    buildUrlParams() {
      const params = { page: this.currentPage, pageSize: this.pageSize, ...this.filterParams };
      return _.omit(params, ['page', 'pageSize']);
    },
  },
};
</script>

<style lang="scss">
.debt-installment-warranty-pagination {
  &__total {
    font-weight: 500;
  }
  &__nav .page-item.disabled {
    cursor: not-allowed;
  }
}
</style>
